import type { RunSkuPreviewAttribute } from "@nova-ai/shared"

import { cn } from "../../lib/utils"

type AttributeSource = RunSkuPreviewAttribute["source"]

// Provenance dot colours: info = read from a fact/copy, a solid neutral grey =
// derived (lookup/transform/template/image_pick), warning = AI, destructive =
// human override, solid neutral = system automation, a faint grey = a fixed literal. The source
// word is printed beside the dot, so the hue is reinforcement, not the only
// signal. The badge stays a calm outlined tag — the dot doesn't shout.
const SOURCE_DOT_COLORS: Record<AttributeSource, string> = {
  static: "bg-muted-foreground/40",
  fact: "bg-info",
  copy: "bg-info",
  lookup: "bg-muted-foreground",
  transform: "bg-muted-foreground",
  template: "bg-muted-foreground",
  image_pick: "bg-muted-foreground",
  nutrition_table: "bg-muted-foreground",
  ai_generate: "bg-warning",
  ai_override: "bg-warning",
  human_override: "bg-destructive",
  system_override: "bg-muted-foreground",
  manual: "bg-muted-foreground/40",
}

export function SourceBadge({ source }: { source: AttributeSource }) {
  return (
    <span className="inline-flex items-center gap-1 rounded border border-border bg-muted/40 px-1.5 py-0.5 text-xs font-medium text-muted-foreground">
      <span className={cn("size-1 rounded-full", SOURCE_DOT_COLORS[source])} />

      {source}
    </span>
  )
}
